import apiService from "./api";
import { sanitizeQueryParams } from "../utility/helpers/apiHelper";

interface Role {
  id: string | number;
  name: string;
  permissions?: string[];
  status?: string;
}

interface AddRole {
  name: string;
  shortDescription: string;
  permissions?: number[];
  status?: string;
}

interface GetRolesParams {
  page?: number;
  limit?: number;
  search?: string;
  [key: string]: any;
}


export class RoleService {
  // Get paginated roles
  async getRoles(query?: GetRolesParams) {
    return apiService.get("/roles", {
      params: sanitizeQueryParams(query || {}),
    });
  }

  // Get roles dropdown (used for filters/assignments)
  async getRolesDropdown() {
    return apiService.get("/roles", {
      params: { source: "dropdown" },
    });
  }

  // Get role by ID
  async getRole(id: string | number) {
    return apiService.get(`/roles/${id}`);
  }

  // Create role
  async createRole(data: Partial<AddRole>) {
    return apiService.post("/roles", data);
  }

  async createPermission(data: Partial<any>) {
    return apiService.post("/permissions", data);
  }

  // Update role
  async updateRole(id: string | number, data: Partial<AddRole>) {
    return apiService.put(`/roles/${id}`, data);
  }
  async updatePermission(id: string | number, data: Partial<AddRole>) {
    return apiService.put(`/permissions/${id}`, data);
  }
  // Delete role
  async deleteRole(id: string | number) {
    return apiService.delete(`/roles/${id}`);
  }

  async deletePermission(id: string | number) {
    return apiService.delete(`/permissions/${id}`);
  }

  // Get permissions for role creation/editing
  async getPermissions(query?: GetRolesParams) {
    return apiService.get("/permissions", {
      params: sanitizeQueryParams(query || {}),
    });
  }

  // Get permission list of a role
  async getRolePermissions(id: string | number) {
    return apiService.get(`/roles/${id}/permissions`);
  }
}

// Export single instance
export const roleService = new RoleService();
